module.exports = __webpack_public_path__ + "static/top-technologies-implemented.24ffd7d3.svg";